var map = {
	"./A0000.png": 961,
	"./A0001.png": 962,
	"./A0002.png": 963,
	"./A0003.png": 964,
	"./A0004.png": 965,
	"./A0005.png": 966,
	"./A0006.png": 967,
	"./A0007.png": 968,
	"./B0000.png": 969,
	"./B0001.png": 970,
	"./B0002.png": 971,
	"./B0003.png": 972,
	"./B0004.png": 973,
	"./B0005.png": 974,
	"./B0006.png": 975,
	"./B0007.png": 976,
	"./C0000.png": 977,
	"./C0001.png": 978,
	"./C0002.png": 979,
	"./C0003.png": 980,
	"./C0004.png": 981,
	"./C0005.png": 982,
	"./C0006.png": 983,
	"./C0007.png": 984,
	"./D0000.png": 985,
	"./D0001.png": 986,
	"./D0002.png": 987,
	"./D0003.png": 988,
	"./D0004.png": 989,
	"./D0005.png": 990,
	"./D0006.png": 991,
	"./D0007.png": 992,
	"./E0000.png": 993,
	"./E0001.png": 994,
	"./E0002.png": 995,
	"./E0003.png": 996,
	"./E0004.png": 997,
	"./E0005.png": 998,
	"./E0006.png": 999,
	"./E0007.png": 1000,
	"./F0000.png": 1001,
	"./F0001.png": 1002,
	"./F0002.png": 1003,
	"./F0003.png": 1004,
	"./F0004.png": 1005,
	"./F0005.png": 1006,
	"./F0006.png": 1007,
	"./F0007.png": 1008,
	"./G0000.png": 1009,
	"./G0001.png": 1010,
	"./G0002.png": 1011,
	"./G0003.png": 1012,
	"./G0004.png": 1013,
	"./G0005.png": 1014,
	"./G0006.png": 1015,
	"./G0007.png": 1016,
	"./H0000.png": 1017,
	"./H0001.png": 1018,
	"./H0002.png": 1019,
	"./H0003.png": 1020,
	"./H0004.png": 1021,
	"./H0005.png": 1022,
	"./H0006.png": 1023,
	"./H0007.png": 1024,
	"./I0000.png": 1025,
	"./I0001.png": 1026,
	"./I0002.png": 1027,
	"./I0003.png": 1028,
	"./I0004.png": 1029,
	"./I0005.png": 1030,
	"./I0006.png": 1031,
	"./I0007.png": 1032,
	"./J0000.png": 1033,
	"./J0001.png": 1034,
	"./J0002.png": 1035,
	"./J0003.png": 1036,
	"./J0004.png": 1037,
	"./J0005.png": 1038,
	"./J0006.png": 1039,
	"./J0007.png": 1040,
	"./K0000.png": 1041,
	"./K0001.png": 1042,
	"./K0002.png": 1043,
	"./K0003.png": 1044,
	"./K0004.png": 1045,
	"./K0005.png": 1046,
	"./K0006.png": 1047,
	"./K0007.png": 1048,
	"./L0000.png": 1049,
	"./L0001.png": 1050,
	"./L0002.png": 1051,
	"./L0003.png": 1052,
	"./L0004.png": 1053,
	"./L0005.png": 1054,
	"./L0006.png": 1055,
	"./L0007.png": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;